import { createContext } from 'react';
import { TabBadger } from 'utils/services/TabBadger';

export const TabBadgerContext = createContext<TabBadger | null>(null);
